import React, { memo } from 'react';
import classnames from 'classnames';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

function style() {
  return {
    loading: {
      display: 'none',
      position: 'absolute',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1,
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
    },
    isVisible: {
      display: 'flex',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
    },
  };
}

interface IProps {
  isVisible: boolean;
  // eslint-disable-next-line react/require-default-props
  text?: string;
}

interface IClassNames {
  loading: string;
  isVisible: string;
}

interface IMergedProps extends IProps {
  classes: IClassNames;
}

function UnstyledLoading({ isVisible, classes, text }: IMergedProps) {
  const rootClassName = classnames(classes.loading, isVisible ? classes.isVisible : '', 'loading');
  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <div className={rootClassName}>
      <Spinner size={SpinnerSize.large} label={text || 'Loading...'} />
    </div>
  );
}

UnstyledLoading.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  isVisible: false,
};

// @ts-ignore
export const Loading: React.FC<IProps> = withDefaultStyles(memo(UnstyledLoading), style);
